import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import IconButtonNonReact from '../components/IconButtonNonReact';
import Urls from '../urls/Urls';
import UrlHelper from '../core/UrlHelper';
import E from '../ui_core/E';
import PlotStatus from '../site/PlotStatus';
import AssetsManager from '../assets_management/AssetsManager';
import HouseTypesViewerEntryStatuses from './HouseTypesViewerEntryStatuses';
import HouseTypesViewerEntryPriceRange from './HouseTypesViewerEntryPriceRange';
import HouseGridSelectorInfo from './HouseGridSelectorInfo';
import Checkbox from '../components/Checkbox';
import Star from '../components/Star';
export default class HouseTypesViewerEntry {
	constructor({houseTypes, callbackClicked, houseTypeViewModel, showImagesFullScreen,
		showStreetView, enterHouse, hide, callbackAddFavourite, callbackRemoveFavourite,
		configuration}){
		this._callbackHide =hide;
		this._callbackClicked = callbackClicked;
		this._callbackAddFavourite = callbackAddFavourite;
		this._callbackRemoveFavourite = callbackRemoveFavourite;
		this._showImagesFullScreen= showImagesFullScreen;
		this._showStreetView = showStreetView;
		this._enterHouse= enterHouse;
		this._houseTypes = houseTypes;
		this._houseTypeViewModel = houseTypeViewModel;
		
		this._handleClicked= this._handleClicked.bind(this);
		this._element = document.createElement('div');
		this._element.classList.add('house-grid-selector-entry');
		this._imageWrapperElement = document.createElement('div');
		this._imageWrapperElement.classList.add("image-wrapper");
		this._img = document.createElement('img');
		this._img.classList.add('image');
		const firstHouseTypeWithName = houseTypes[0];
		const firstPlot = firstHouseTypeWithName.plots[0];
		this._firstPlot = firstPlot;
		const firstUnit = firstPlot.unit;
		this._img.src = firstUnit.frontViewImage?`${Urls.getAssetsForSite(configuration.siteSlug)}${UrlHelper.removeStartSlash(firstUnit.frontViewImage.getBestEntryToFitHeight(500).relativePath)}`:null;

		const description = E.div('description');
		this._nameElement = document.createElement('div');
		this._nameElement.classList.add('name');
		console.log('houseTypes');
		console.log(houseTypes[0]);
		const houseType = houseTypes[0];
		const plots = houseType.plots;
		let minPrice = null, maxPrice = null;
		const mapStatusToNEntries = new Map();
		plots.forEach(p=>{
			let statusNEntries = mapStatusToNEntries.get(p.status);
			if(statusNEntries){
				statusNEntries.nEntries++;
			}
			else{
				statusNEntries = {nEntries:1, status:p.status};
				mapStatusToNEntries.set(p.status, statusNEntries);
			}
			if(p.status===PlotStatus.AVAILABLE){
				if(minPrice===null||minPrice===undefined||minPrice===0){
					minPrice = p.price;
					maxPrice = p.price;
					return;
				}
				if(p.price<minPrice&&p.price!==0){
					minPrice = p.price;
				}
				if(p.price>maxPrice){
					maxPrice = p.price;
				}
			}
		});
		const statusNEntries = Array.from(mapStatusToNEntries.values());
		this._nameElement.textContent = houseTypes[0].name;
		this._element.appendChild(this._imageWrapperElement);
		this._imageWrapperElement.appendChild(this._img);
		description.appendChild(this._nameElement);
		const nOfEachStatus = E.div('n-of-each-status');
		let statusString = '';
		let hasAvailable =false;
		statusNEntries.forEach(s=>{
			if(statusString.length>0)
				statusString+=', ';
			if(s.status===PlotStatus.AVAILABLE)
				hasAvailable = true;
			statusString+=`${s.nEntries} ${PlotStatus.getDescription(s.status)}`;
		});
		nOfEachStatus.textContent = statusString;
		description.appendChild(nOfEachStatus);
		const priceRange = E.div('price-range');
		if(minPrice!==0&&hasAvailable){
			priceRange.textContent = minPrice===maxPrice?`£${minPrice}`:`£${minPrice} - £${maxPrice}`;
		}
		description.appendChild(priceRange);
		const squareFeet = E.div('square-feet');
		squareFeet.textContent = houseType.sqrft;
		description.appendChild(squareFeet);
		this._element.appendChild(description);
		this._element.addEventListener('click', this._handleClicked);
		this._element.addEventListener('mouseenter', ()=>this._element.classList.add('hovering'));
		this._element.addEventListener('mouseleave', ()=>this._element.classList.remove('hovering'));
		
	}
	get houseType(){
		return this._houseTypes[0];
	}
	get element(){
		return this._element;
	}
	_handleClicked(){
		this._callbackClicked(this);
	}
}
